import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
import Select from "react-select"
 

const UserWalletCreate = ()=>{
     const [user, setUser ] = useState('');
     const [bookBalance, setBookBalance ] = useState('');
     const [availableBalance, setAvailableBalance ] = useState('');
     const [dateLastWithdrawal, setDateLastWithdrawal ] = useState('');
     const [amountLastWithdrawal, setAmountLastWithdrawal ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const [loading, setLoading] = useState(false);
     const [hasError, setHasError] = useState(false);
     const [errorMessage, setErrorMessage] = useState('');
     const [users, setUsers] = useState([]);
     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('userWallet', {
            user_id:parseInt(user),
            book_balance:parseInt(bookBalance),
            available_balance:parseInt(availableBalance),
            date_last_withdrawal:dateLastWithdrawal,
            amount_last_withdrawal: parseInt(amountLastWithdrawal),
        });
        console.log(data);
        setRedirect(true);
     }

     useEffect(() => {
        const fetchUsers = async () => {
           setLoading(true);
           setHasError(false);
           setErrorMessage('');
     
           try {
             const { data } = await axios.get(`users?page=${1}`);
             setUsers(data.data);
               console.log(data.data);
           } catch (error) {
             if (error.response) {
               // The request was made and the server responded with a status code
               // that falls out of the range of 2xx
               if (error.response.status === 401) {
                 setErrorMessage("Unauthorized access.");
               } else if (error.response.status === 400) {
                 setErrorMessage("Bad request. Please check your input.");
               }
               else if (error.response.status === 500) {
                 setErrorMessage("Insufficient Permissions");
               }
               else {
                 setErrorMessage("An error occurred. Please try again later.");
               }
             } else if (error.request) {
               // The request was made but no response was received
               if (error.message === "Network Error") {
                 setErrorMessage("Failed to connect to the server. Please try again later.");
               } else {
                 setErrorMessage("No response received. Please try again later.");
               }
             } else {
               // Something happened in setting up the request that triggered an Error
               setErrorMessage("An error occurred. Please try again later.");
             }
             setHasError(true);
           } finally {
             setLoading(false);
           }
         };
     
         fetchUsers();
       }, []);

    if(redirect){
        return <Navigate to={'/userWallet'} />
    }
     return (
         <Wrapper pageTitle={"New UserWallet"}>
            <InnerNav createLink={'/userWalletCreate'} listLink={'/userWallet'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">User </span>
                        <Select  options={users.map(user => ({
    value: user.id,
    label: `${user.first_name} ${user.last_name}`.trim()
  }))} onChange={(selectedOption) => setUser(selectedOption.value)}  className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-20 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "/>
                       
                         
                        
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">BookBalance </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="BookBalance"
                        onChange = {e => setBookBalance(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">AvailableBalance </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="AvailableBalance"
                        onChange = {e => setAvailableBalance(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">DateLastWithdrawal </span>
                        <input type="date"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="DateLastWithdrawal"
                        onChange = {e => setDateLastWithdrawal(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">AmountLastWithdrawal </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="AmountLastWithdrawal"
                        onChange = {e => setAmountLastWithdrawal(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default UserWalletCreate;